import React, { PureComponent } from 'react';
import * as AppActions from '../../modules/App/AppState';

class SelectMenu extends PureComponent {

  constructor() {
    super();

    this.onOptionSelect = this.onOptionSelect.bind(this);
  }

  onOptionSelect(evt) {
    if (evt.target.value === 'default') {
      this.props.dispatch(AppActions.resetGroupFilter());
      return false;
    }
    this.props.dispatch(AppActions.setDataSet(evt.target.value));
  }

  render() {
    const options = this.props.items.map((item, i) => {
      return (<optgroup className="ifdw-menu--select-optgroup" key={`ifdw-menu--select-optgroup_${i}`} label={item.cat}>{
        item.groups.map((group, j) => <option value={group[1]} key={`ifdw-menu--select-option_${j}`}>{group[0]}</option>)
      }</optgroup>);
    });

    return (
      <select onChange={this.onOptionSelect} className="ifdw-menu--select" defaultValue='default'>
        <option value="default">Bevölkerungsgruppe auswählen</option>
        {options}
      </select>
    )
  }
}

export default SelectMenu;



/** WEBPACK FOOTER **
 ** ./src/components/Menu/SelectMenu.js
 **/